export default "__VITE_ASSET__BnELj6WH__"